import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ProjectBackupIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14.026 19.7117L4.77377 19.7116C3.44828 19.7116 2.37377 18.6371 2.37378 17.3116L2.37387 8.18729C2.37388 7.27337 2.37354 5.97164 2.37325 5.02909C2.37304 4.36617 2.91038 3.8294 3.5733 3.8294H9.29151L12.0565 6.78303H20.3728C21.0356 6.78303 21.5728 7.32029 21.5728 7.98303V11.1706M16.8268 16.6132L19.281 14.1706M19.281 14.1706L21.6268 16.5028M19.281 14.1706V20.1706"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.39531 17.3V9.3H8.55156C9.15833 9.3 9.67526 9.41589 10.1023 9.64766C10.5294 9.87682 10.8549 10.1958 11.0789 10.6047C11.3055 11.0109 11.4188 11.4797 11.4188 12.0109C11.4188 12.5422 11.3042 13.0109 11.075 13.4172C10.8458 13.8234 10.5138 14.1398 10.0789 14.3664C9.64662 14.593 9.12318 14.7063 8.50859 14.7063H6.49688V13.3508H8.23516C8.56068 13.3508 8.82891 13.2948 9.03984 13.1828C9.25339 13.0682 9.41224 12.9107 9.51641 12.7102C9.62318 12.507 9.67656 12.274 9.67656 12.0109C9.67656 11.7453 9.62318 11.5135 9.51641 11.3156C9.41224 11.1151 9.25339 10.9602 9.03984 10.8508C8.8263 10.7388 8.55547 10.6828 8.22734 10.6828H7.08672V17.3H5.39531Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

ProjectBackupIcon.displayName = 'ProjectBackupIcon';
